import React, { useMemo } from 'react';
import { DateInput, CommonDateInputProps, FormFieldsData } from 'framework/form';
import { get } from 'lodash';
import { OPDateIcon } from 'framework/ui/mui-builder';

const OriginalPlannedDateInput = (props: CommonDateInputProps) => {
  const parentSource = useMemo(() => {
    return props.source.substring(0, props.source.lastIndexOf('.'));
  }, [props.source]);

  const isDisabled = (values?: FormFieldsData) => {
    const disabled = props.disabled;

    if (!disabled || typeof disabled === 'boolean') {
      return disabled || false;
    }

    const recalculatedParentValue = get(values, parentSource);
    return disabled(recalculatedParentValue);
  };

  return (
    <DateInput
      {...props}
      disabled={isDisabled}
      dateIcon={
        <OPDateIcon
          sx={{
            marginRight: '10px',
            fontSize: '1.2rem',
            position: 'absolute',
            zIndex: 1,
            left: '10px',
            top: '8px',
            opacity: '0.8',
          }}
        />
      }
    />
  );
};
export default OriginalPlannedDateInput;
